import {Ability} from '@casl/ability'

export const ability = new Ability()

export const abilityPlugin = (store) => {
	ability.update(store.state.rules);
	return store.subscribe((mutation) => {
		switch (mutation.type) {
			case 'loginSuccess':
				let formattedRules = [];
				if(mutation.payload.permissions.length > 0) {
					formattedRules = mutation.payload.permissions.map(perm => {
						let formattedObj = {};
						formattedObj.actions = perm.substr(0, perm.indexOf(' '));
						formattedObj.subject = perm.substr(perm.indexOf(' ')+1);
						return formattedObj;
					})
				}
				ability.update(formattedRules);
				break
			case 'logoutSuccess':
				ability.update([{ actions: 'read', subject: 'all' }])
				break
		}
	})
}
